import logo from './logo.svg';
import './App.css';
import Input from './components/input';
import Card from './components/weathercard';
import Btn from './components/button';
// Import the new Layout
import Layout from './components/Layout'; 
import { ContextProvider } from './contextprovider/weather'; // Ensure context is wrapping everything

function App() {
  return (
    // Note: ContextProvider must be OUTSIDE Layout so Layout can read the data
    <ContextProvider>
      <Layout>
          <Input />
          <br /> {/* Spacing */}
          <Btn />
          <br /> {/* Spacing */}
          <Card />
      </Layout>
    </ContextProvider>
  );
}

export default App;